import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-background via-muted/30 to-accent/10 py-20 lg:py-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="absolute top-20 right-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1 space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
                <Icon name="Sparkles" size={16} />
                  <span>Full-Stack Engineer & Open Source Advocate</span>
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-foreground leading-tight">
                  Building Impactful
                  <span className="text-gradient-brand block">Software</span>
                  For Developers
              </h1>
              
                <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed max-w-2xl">
                  I'm Mustan Aliev, a passionate full-stack engineer and open source contributor. My work spans modern web, cloud, and AI, with a focus on developer tools and automation. 
                  Explore my GitHub for real-world projects, frameworks, and solutions trusted by the community.
                </p>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 py-6 border-t border-b border-border/50">
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-primary">150+</div>
                <div className="text-sm text-muted-foreground">Projects Delivered</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-accent">4+</div>
                <div className="text-sm text-muted-foreground">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-success">50+</div>
                <div className="text-sm text-muted-foreground">Happy Clients</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="Download"
                iconPosition="left"
                className="bg-gradient-brand hover:shadow-brand">

                Download Resume
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="hover-lift">

                Schedule a Call
              </Button>
            </div>
          </div>

          {/* Profile Image */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative">
              {/* Main Image Container */}
              <div className="relative w-80 h-80 lg:w-96 lg:h-96 rounded-3xl overflow-hidden shadow-brand-lg hover-lift">
                <Image
                  src="https://github.com/Mustan-dev.png"
                  alt="GitHub profile picture of Mustan-dev"
                  className="w-full h-full object-cover" />

                
                {/* Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 via-transparent to-transparent"></div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-card border border-border rounded-2xl p-4 shadow-brand-lg animate-bounce">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium text-card-foreground">Available for work</span>
                </div>
              </div>

              <div className="absolute -bottom-4 -left-4 bg-card border border-border rounded-2xl p-4 shadow-brand-lg">
                <div className="flex items-center space-x-3">
                  <Icon name="Code2" size={20} className="text-primary" />
                  <div>
                    <div className="text-sm font-medium text-card-foreground">Currently Building</div>
                    <div className="text-xs text-muted-foreground">AI-Powered Analytics</div>
                  </div>
                </div>
              </div>

              {/* Background Decoration */}
              <div className="absolute -z-10 top-8 left-8 w-full h-full bg-gradient-brand rounded-3xl opacity-20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;
